import styled from 'styled-components';
import { RowStyled } from '../RowStyled';

export const RowStyledAP = styled(RowStyled)``;
